import { put, call } from "redux-saga/effects";

import { SAVE_TOKEN_COMPLETED,SAVE_TOKEN_FAILED} from "../actions/Token";

import {  TokenAPI } from "../../utils/api/LoginAPI";



export function* saveToken(request: any) {
 
   
    try {
 
         const result=yield call(TokenAPI.saveToken, request.input);
   
        yield put({
            
            type: SAVE_TOKEN_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
     
        yield put({ type: SAVE_TOKEN_FAILED, payload: e.message });
    }
}